import { useEffect, useMemo } from 'react'
import { AxiosError } from 'axios'

import { useQuery } from '@tanstack/react-query'

import { useDispatch } from '@tabeeb/store'
import { onAddErrorNotification } from '@tabeeb/modules/notification/actions'
import { ApiErrorResponse } from '@tabeeb/contracts/main-api/swagger-main-api'
import getErrorMessageFromResponse from '@tabeeb/modules/shared/utils/getErrorMessageFromResponse'
import { useApi } from '@tabeeb/modules/shared/utils/API/hooks'

import { CertificatesQueryKeys } from '../queries'

const useCertificateCategories = () => {
  const dispatch = useDispatch()
  const { certificateServiceApi: api } = useApi()

  const categoriesQuery = useQuery({
    queryKey: [CertificatesQueryKeys.CertificateCategories],
    queryFn: api.certificateCategories.getAllAsync,
  })

  const { isError: isCategoriesError, error: categoriesError } = categoriesQuery

  useEffect(() => {
    if (isCategoriesError && categoriesError) {
      const error = categoriesError as AxiosError<ApiErrorResponse>
      const message = getErrorMessageFromResponse(error.response?.data)
      dispatch(onAddErrorNotification({ message }))
    }
  }, [isCategoriesError, categoriesError, dispatch])

  return useMemo(
    () => ({
      categories: categoriesQuery.data ?? [],
      loading: categoriesQuery.isLoading || categoriesQuery.isFetching,
      onReload: categoriesQuery.refetch,
    }),
    [categoriesQuery.data, categoriesQuery.isFetching, categoriesQuery.isLoading, categoriesQuery.refetch]
  )
}

export default useCertificateCategories
